/**
 * FormError Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { Span } from '../../text/Label';

interface IOwnProps {
  error: string;
}

const classes = new BEM('form-error');

const FormError: React.SFC<IOwnProps> = ({ error }: IOwnProps) => (
  <div {...classes() }><Span size="medium">{error}</Span></div>
);

export default FormError;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/feedback/FormError/index.tsx